// extracted by mini-css-extract-plugin
export default {"img-size":"HeroDetail_img-size__rtKi5"};